package pl.decks.personal.components.animations

import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.percent

object PushFromTopAnimation {
    object Vars {
        val fromBase by StyleVariable<CSSLengthOrPercentageNumericValue>(0.percent)
        val toMargin by StyleVariable<CSSLengthOrPercentageNumericValue>(0.percent)
    }

    val Frames = Keyframes {
        from { Modifier.margin(top = Vars.fromBase.value()) }
        to { Modifier.margin(top = Vars.toMargin.value()) }
    }
}
